import { ISpecialization } from "./specialization";

export interface ISchool {
    id?: string;
    name: string;
    slug:string;
    contact_email: string;
    address: string;
    logo?: string;
    principal_signature?: string;
    settings: SchoolSettings;
    contact_phone: string;
    description?: string;
    specializations?: ISpecialization[];
    type: SchoolTypes;
    parent_id?: string;
    owner_id?: string;
    createdAt?: Date;
    updatedAt?: Date;
    deleteAt?: Date;
}

export interface Range {
    from: number;
    to: number;
}
export interface SchoolSettings {
    remarks: {
        poor: Range,
        below_average: Range,
        average: Range,
        good: Range,
        very_good: Range,
        excellent: Range,
    };
    class_council_decision: {
        dismissed: Range,
        repeat: Range,
        passed: Range,
        promoted: Range,
    };
    next_year_resumption: Date | string;
    next_term_resumption: Date | string;
    academic_year_start: Date | string;
    academic_year_end: Date | string;

    notifications: {
        next_year_resumption: boolean;
        academic_year_start: boolean;
        academic_year_end: boolean;
    };
    grading_system: {
        open_all_semester_sequences: boolean;
        enable_auto_evaluation_creation: boolean;
        enable_auto_evaluation_publication: boolean;
        enable_auto_result_publication: boolean;
        next_semester_start: Date;
        next_semester_end: Date;
        next_sequence_start: Date;
        next_sequence_end: Date;
        evaluation_due_date: Date;
    };
    results: {
        enable_results_processing: boolean;
        publish_results: boolean;
        use_cba_report_card?: boolean;
        stamp_principal_signature?: boolean;
    }
}

export enum SchoolTypes {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    HIGHER = 'HIGHER',
    UNIVERSITY = 'UNIVERSITY'
}

export enum Sequences {
    FIRST_SEQUENCE = "first sequence",
    SECOND_SEQUENCE = "second sequence",
    THIRD_SEQUENCE = "third sequence",
    FOURTH_SEQUENCE = "fourth sequence",
    FIFTH_SEQUENCE = "fifth sequence",
    SIXTH_SEQUENCE = "sixth sequence",
    CONTINUOUS_ASSESSMENT = "continuous assessment",
    EXAM = "semester exams",
}

export enum Semesters {
    FIRST_SEMESTER = "first semester",
    SECOND_SEMESTER = "second semester",
    RESIT_SEMESTER = "resit semester",
}

export enum Terms {
    FIRST_TERM = "first term",
    SECOND_TERM = "second term",
    THIRD_TERM = "third term",
}

export interface SchoolTypeConfig {
    type: SchoolTypes;
    labels: {
        subject: string;
        student: string;
        evaluation: string;
        term: string;
        courseRegistration: string;
        studentRegistration: string;
        academicLevel: string;
        sequence: string;
        semester: string;
        department: string;
        specialization: string;
    };
    features: {
        requiresCourseRegistration: boolean;
        requiresStudentRegistration: boolean;
        usesPromotion: boolean;
        usesSemesters: boolean;
        usesTerms: boolean;
        usesSequences: boolean;
        usesClassrooms: boolean;
    };
}
